import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'app-excel-chart-paste',
    templateUrl: './excel-chart-paste.component.html',
    styleUrls: ['./excel-chart-paste.component.scss']
})
export class ExcelChartPasteComponent implements OnInit {
    static MAX_WIDTH = 600;
    static MAX_HEIGHT = 400;

    @ViewChild('paint', {static: true}) paint: ElementRef;

    image: any = null;
    focused = false;

    @Output() onFileSelected: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    onClick() {
        this.focused = true;
    }

    onBlur() {
        this.focused = false;
    }

    handlePaste(pasteEvent) {
        if (pasteEvent.clipboardData === false) {
            return;
        }

        const items = pasteEvent.clipboardData.items;
        if (items === undefined) {
            return;
        }

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") === -1) {
                continue;
            }

            const blob = items[i].getAsFile();
            this.displayImageOnCanvas(blob);
        }
    }

    displayImageOnCanvas(imageBlob) {
        if (!imageBlob) {
            return;
        }

        const canvas = document.getElementById("canvas") as any;
        const context = canvas.getContext('2d');
        const img = new Image();

        img.onload = function () {
            // Resize image while maintaining aspect ration
            if (img.width > ExcelChartPasteComponent.MAX_WIDTH) {
                img.height *= ExcelChartPasteComponent.MAX_WIDTH / img.width;
                img.width = ExcelChartPasteComponent.MAX_WIDTH;
            }

            if (img.height > ExcelChartPasteComponent.MAX_HEIGHT) {
                img.width *= ExcelChartPasteComponent.MAX_HEIGHT / img.height;
                img.height = ExcelChartPasteComponent.MAX_HEIGHT;
            }

            canvas.width = img.width;
            canvas.height = img.height;
            context.drawImage(img, 0, 0, img.width, img.height);
        };

        const URLObj = window.URL;
        img.src = URLObj.createObjectURL(imageBlob);
        imageBlob.objectUrl = URLObj.createObjectURL(imageBlob);
        this.image = imageBlob;
        this.onFileSelected.emit(imageBlob);
    }

    handleReset() {
        const canvas = document.getElementById("canvas") as any;
        const context = canvas.getContext('2d');
        context.clearRect(0, 0, ExcelChartPasteComponent.MAX_WIDTH, ExcelChartPasteComponent.MAX_HEIGHT);
        this.image = null;
    }
}
